<template>
  <div>
    <v-autocomplete
      :items="usersList"
      item-value="id"
      item-text="fullName"
      v-model="userIdValue"
      :label="labelValue"
      :clearable="clearable"
      :rules="[requiredCheck()]"
      :readonly="readonly"
      :append-icon="readonly ? null : '$dropdown'"
      outlined
      :hide-details="hideDetails ? hideDetails : false"
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'userId',
    'isRequired',
    'clearable',
    'label',
    'readonly',
    'securityRoles',
    'hideDetails',
    'onlyActiveUsers'
  ],
  data () {
    return {
      usersList: []
    }
  },
  computed: {
    userIdValue: {
      get () {
        return this.userId
      },
      set (newValue) {
        this.$emit('userIdChange', newValue)
        let user = this.usersList.find((element) => {
          return element.id === newValue
        })
        this.$emit('userNameChange', user.firstName, user.lastName)
        this.$emit('userRoleChange', user.securityRoles)
      }
    },
    labelValue: {
      get () {
        return this.label ? this.label : 'User'
      }
    }
  },
  methods: {
    ...mapActions('users', [
      'getUsers'
    ]),
    requiredCheck () {
      return !this.isRequired || required(this.labelValue)
    },
    getSecurityRolesArray (securityRolesConstants) {
      let securityRolesArray = []
      for (const role of securityRolesConstants) {
        securityRolesArray.push(role.name)
      }
      return securityRolesArray
    }
  },
  created () {
    let filters = {}
    if (this.securityRoles) {
      filters.SecurityRoles = this.getSecurityRolesArray(this.securityRoles)
    }
    if (this.onlyActiveUsers !== null) {
      filters.active = this.onlyActiveUsers
    }
    this.getUsers(filters).then((users) => { this.usersList = users })
  }
}
</script>
